(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pewnesklepy-consent"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pewnesklepy-consent')) {
    class PewneSklepyConsent extends HTMLElement {
      static pending = false;
      static failed = false;
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.querySelector('input[type=checkbox]').disabled = PewneSklepyConsent.pending;
        this.querySelector('input[type=checkbox]').addEventListener('change', () => this.save());
        this.querySelector('.ps-consent__retry').addEventListener('click', () => this.save());
      }
      async save() {
        if (PewneSklepyConsent.pending) return;
        const checked = this.querySelector('input[type=checkbox]').checked;
        const attributes = {pewnesklepy_consent: checked ? 'shopify-cart-2026-10-10-v1' : '', pewnesklepy_consent_at: checked ? new Date().toISOString() : ''};
        PewneSklepyConsent.pending = true;
        PewneSklepyConsent.failed = false;
        const update = (status) => document.querySelectorAll('pewnesklepy-consent').forEach(el => {
          const input = el.querySelector('input[type=checkbox]');
          input.checked = checked;
          input.disabled = PewneSklepyConsent.pending;
          el.querySelector('.ps-consent__status').textContent = el.dataset[status];
          el.querySelector('.ps-consent__retry').hidden = status !== 'error';
          for (const [key, value] of Object.entries(attributes)) el.querySelector('input[name="attributes['+key+']"]').value = value;
        });
        update('saving');
        try {
          const response = await fetch(this.dataset.root + 'cart/update.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({attributes})});
          if (!response.ok) throw new Error('cart');
          const cart = await response.json();
          if ((cart.attributes.pewnesklepy_consent || '') !== attributes.pewnesklepy_consent) throw new Error('choice');
          PewneSklepyConsent.pending = false;
          update('saved');
        } catch (_) {
          PewneSklepyConsent.pending = false;
          PewneSklepyConsent.failed = true;
          update('error');
        }
      }
    }
    customElements.define('pewnesklepy-consent', PewneSklepyConsent);
    // Avoid proceeding with an earlier consent while its revocation is still saving.
    const guard = (event) => {
      if (!PewneSklepyConsent.pending && !PewneSklepyConsent.failed) return;
      const target = event.target;
      if (event.type === 'submit' || target.closest('[name=checkout],a[href*="/checkout"],shopify-accelerated-checkout-cart,.additional-checkout-buttons')) {
        event.preventDefault(); event.stopImmediatePropagation();
        document.querySelector('pewnesklepy-consent input[type=checkbox]')?.focus();
      }
    };
    document.addEventListener('click', guard, true);
    document.addEventListener('submit', event => {
      if (event.target.matches('form[action*="/cart"]')) guard(event);
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
